import { Component, OnInit, ViewChild, Input, Output, Inject, LOCALE_ID, EventEmitter, AfterViewInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DxDataGridComponent } from "devextreme-angular";
import { MessageDialog } from "../../../components/message-dialog/messageDialog";
import { A3LCompanyAgreements } from "../../../core/models/a3LCompanyAgreements.model";
import { ConveniosEmpresa } from "../../../core/models/conveniosEmpresa.model";
import { DatosCalculoBolsaVacaciones } from "../../../core/models/datosCalculo.model";
import { Provincia } from "../../../core/models/provincia.model";
import { A3LCompanyService } from "../../../core/services/a3LCompany.service";
import { ProvinciaService } from "../../../core/services/provincias.service";
import { ETipoDia } from "../../../core/Enums/eTipoDia.enum";
import { Utilidades } from "../../../core/helper/utilidades";
import { A3LCompanyPayConcepts } from "../../../core/models/a3LCompanyPayConcepts.model";
import { EnumConceptType } from "../../../core/Enums/EConceptType.enum";
import { EOrigenDatos } from "../../../core/Enums/EOrigenDatos.enum";
import { Column } from "devextreme/ui/data_grid";
import { ConveniosEmpresaService } from '../../../core/services/conveniosEmpresa.service';
import { DatoCalculoService } from '../../../core/services/datosCalculo.service';
import { DxPopupComponent } from 'devextreme-angular';

class PagaExtraItem {
  nombre: string;

  constructor(nombre: string) {
    this.nombre = nombre;
  }
}

@Component({
  selector: 'app-convenios-list',
  templateUrl: './convenios-list.component.html',
  styleUrls: ['./convenios-list.component.scss'],
  providers: [A3LCompanyService, ProvinciaService, ConveniosEmpresaService, DatoCalculoService]
})
export class ConveniosListComponent implements OnInit, AfterViewInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  @Input() companyCode: string;
  @Input() esEditable = false;
  @Input() convenioEmpresa: ConveniosEmpresa;

  @Output() onGridUpdated: EventEmitter<any> = new EventEmitter();
  @Output() onClonate: EventEmitter<any> = new EventEmitter();

  isValid: boolean = true;
  tiposDia = Utilidades.enumToArray(ETipoDia);
  convenios: A3LCompanyAgreements[];
  provincias: Provincia[];
  payConcepts: A3LCompanyPayConcepts[] = new Array<A3LCompanyPayConcepts>();
  payConcepts2: A3LCompanyPayConcepts[] = new Array<A3LCompanyPayConcepts>();

  pagasExtra: PagaExtraItem[];
  origenDatos: any[];
  prorrateado: boolean;
  conceptosPaga: any[];
  gridBoxValue: number[] = [3];

  companySelectedAgreementValue: string;
  companySelectedAgreements: ConveniosEmpresa[];
  companySelectedAgreement: ConveniosEmpresa;

  companySelectedAgreementValueClone: string;
  companySelectedAgreementsClone: ConveniosEmpresa[];
  listaConfiguracionesConvenio: DatosCalculoBolsaVacaciones[];
  configuracionSeleccionada: string;

  loading = false;

  @ViewChild(DxPopupComponent) dxPopUp: DxPopupComponent;

  constructor(
    
    @Inject(LOCALE_ID) public locale: string,
    protected _a3lCompanyService: A3LCompanyService,
    protected _provinciasService: ProvinciaService,
    protected _activatedRoute: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _conveniosEmpresaService: ConveniosEmpresaService,
    protected _datosCalculoService: DatoCalculoService
  ) {
    if (this.convenioEmpresa && !this.convenioEmpresa.Calculos) {
      this.convenioEmpresa.Calculos = new Array<DatosCalculoBolsaVacaciones>();
    }
  }

  ngAfterViewInit(): void {
    if (this.dataGrid) {
      this.dataGrid.dataSource = this.convenioEmpresa?.Calculos ?? new Array<DatosCalculoBolsaVacaciones>();
    }
  }

  ngOnInit(): void {
    this.cargarProvincias();
    this.getConcepts(this.companyCode);
    this.cargarOrigen();
  }

  cargarProvincias() {
    this.provincias = undefined;
    this._provinciasService.getAll().subscribe((result: Provincia[]) => {
      this.provincias = result;
    }, error => {
      console.error(error);
    })
  }

  getConvenioDisplayExpr(data: A3LCompanyAgreements) {
    return data.agreementCode.trim() + ' - ' + data.description;
  }

  getConcepts(companyCode: string) {
    this._a3lCompanyService.getPayConcepts(companyCode).subscribe((response: A3LCompanyPayConcepts[]) => {
      if (response) {
        this.payConcepts = response;
      }
    }, error => {
      console.error(error);
    }
    );
  }

  cargarPagasExtra(companyCode: string, agreementCode: string) {
    this.pagasExtra = [];
    if (companyCode && agreementCode) {
      this._a3lCompanyService.getEmployeesExtraPays(companyCode, agreementCode).subscribe((result: string[]) => {
        this.pagasExtra = result.map(r => new PagaExtraItem(r));
      }, error => {
        console.error(error);
      })
    }
  }

  cargarOrigen() {
    this.origenDatos = Utilidades.enumToArray(EOrigenDatos);
  }

  cargarConceptosDatosCalculoYPagasExtra(datosCalculo: DatosCalculoBolsaVacaciones) {

    // Datos por defecto
    datosCalculo.SelectedEmployeeConcept = undefined;
    datosCalculo.ConceptoEmpleadoProrrateado = false;
    datosCalculo.SelectedVariableConcept = undefined;
    datosCalculo.SelectedPayConcepts = [];
    datosCalculo.SelectedPagasExtra = [];

    // Conceptos
    if (datosCalculo?.ConceptosBolsaVacaciones && datosCalculo?.ConceptosBolsaVacaciones?.length > 0) {

      datosCalculo.SelectedPayConcepts = datosCalculo.ConceptosBolsaVacaciones.filter(x => x.TipoConcepto == EnumConceptType.Pay).map(x => parseInt(x.CodigoConcepto));

      const employeeConcept = datosCalculo.ConceptosBolsaVacaciones.find(x => x.TipoConcepto === EnumConceptType.Employee);
      if (employeeConcept && employeeConcept.CodigoConcepto) {
        datosCalculo.SelectedEmployeeConcept = parseInt(employeeConcept.CodigoConcepto);
        datosCalculo.ConceptoEmpleadoProrrateado = employeeConcept.Prorrateado || false;
      }

      const variableConcept = datosCalculo.ConceptosBolsaVacaciones.find(x => x.TipoConcepto === EnumConceptType.Variable);
      if (variableConcept && variableConcept.CodigoConcepto) {
        datosCalculo.SelectedVariableConcept = parseInt(variableConcept.CodigoConcepto);
      }
    }

    // Pagas extra
    if (datosCalculo?.PagasExtra && datosCalculo?.PagasExtra?.length > 0) {

      datosCalculo.SelectedPagasExtra = datosCalculo.PagasExtra.map(x => x.ExtraPayName);
    }
  }

  onDataGridUpdated(e: any) {
    this.onGridUpdated.emit();
  }

  onClonatedItem(elementoClonado: DatosCalculoBolsaVacaciones) {
    this.onClonate.emit(elementoClonado);
  }

  onDataGridUpdating(e: any) {
  }

  onKeyDown(e: any) {
    if (e.event.key === 'Tab') {
      const element: HTMLElement = e.event.target;

      // TODO: Mejorar la identificación del elemento.
      if (element.title === 'Guardar') {

        this.dataGrid.instance.saveEditData().then((value) => {
          if (this.isValid) {
            this.dataGrid.instance.addRow();
            this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(0, 0));
          } else {
            e.event.preventDefault();
            return;
          }
        });

      }
    } else {
      // éste timeout es necesario para que fuerce el evento onchange al obtener una entrada del teclado,
      // y así actualizar el importe total y no tener el problema de necesitar pulsar dos veces el botón de guardar
      setTimeout(() => {
        const evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        e.event.target.dispatchEvent(evt);
      }, 500);
    }
  }

  onRowValidating(e: any) {

    this.isValid = e.isValid;

    let columnIndex = 0;

    if (e.brokenRules.length > 0) {
      columnIndex = e.brokenRules[0].columnIndex - 1;
    }

    this.dataGrid.instance.focus(this.dataGrid.instance.getCellElement(e.key.rowIndex, columnIndex));
  }

  onEditorPreparing(e: any) {
    const standardHandler = e.editorOptions.onValueChanged;

    if (e.parentType === 'dataRow') {

      // Columna artículo
      if (e.dataField === 'productId') {
        e.editorOptions.onValueChanged = (evt: any) => {
          e.component.beginCustomLoading('');
          e.component.endCustomLoading();
        };
      }

      return true;
    }


  }

  onEditingStart(e: any) {
    if (e && e?.data) {
      this.cargarConceptosDatosCalculoYPagasExtra(e?.data);
    }
  }

  onToolbarPreparing(e) {

    const newButtonTemplate = {
      location: 'after',
      template: 'clonateButton'
    };

    e.toolbarOptions.items.unshift(newButtonTemplate);
  }

  mostrarModalClonar() {
    this._conveniosEmpresaService.getAllModels(this.companyCode).subscribe(convenios => {
      this.companySelectedAgreements = convenios ?? new Array<ConveniosEmpresa>();
    },
      error => {
        console.error(error);
      })
    this.dxPopUp.instance.show();
  }

  buttonClonarClick() {
    const elementoEncontrado = this.listaConfiguracionesConvenio.find(c => c.Id === this.configuracionSeleccionada);
    
    if(elementoEncontrado) {
      const clon = Object.assign({}, elementoEncontrado);
      clon.Descripcion = clon.Descripcion + ' - copia';
      this.loading = true;
      this._datosCalculoService.add(clon).subscribe(
        res => {
          const elementoClonado = res;        
          this.onClonatedItem(elementoClonado);
          this.buttonCerrarVentanaClonarClick();
        },
        err => {
          console.error(err);
          this.buttonCerrarVentanaClonarClick();
        }
      );
    }
  }

  buttonCerrarVentanaClonarClick() {
    this.loading = false;
    this.companySelectedAgreementValue = '';
    this.companySelectedAgreementValueClone = '';
    this.configuracionSeleccionada = '';
    this.dxPopUp.instance.hide();
    this.dataGrid.instance.refresh();
  }

  onSelectedAgreementChange(event: any) {

    if (!this.companySelectedAgreementValueClone)
    return;

    const elementoEncontrado = this.companySelectedAgreements.find(c => c.Id === this.companySelectedAgreementValueClone);
    this.listaConfiguracionesConvenio = elementoEncontrado.Calculos;
  }
}
